require('./labelButton.tpl.html');
require('./labelButtonController');

const LabelButtonComponent = {
    templateUrl: '/ui/dropdown/common/labelButton/labelButton.tpl.html',
    controller: 'umLabelButtonController',
    bindings: {
        displayText: '<',
        enabled: '<',
        onClick: '&'
    }
};

angular.module('umCore')
    .component('umLabelButton', LabelButtonComponent);
